import {
  LOG_FIND_ALL,
  LOG_SET_INITIAL_STATE,
  LOG_VIEW
} from './logTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOG_SET_INITIAL_STATE:
      return initialState;
    case LOG_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case LOG_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
